import { pipe } from 'fp-ts/function';
import { array, ord, string } from 'fp-ts';
import { getContainer } from '@mews-commander/legacy-app-instance';
import { DateTimeService } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { CalendarEventExtended } from '../types';

const sortByStartUtc = ord.contramap((event: CalendarEventExtended) => event.startUtc)(string.Ord);

export function getEventsTooltipText(events: CalendarEventExtended[], timezone: string) {
    const container = getContainer();
    const { appLocalizationComponent } = container();
    const { localizeDateTime, localizeText } = appLocalizationComponent;

    return pipe(
        events,
        array.sort(sortByStartUtc),
        array.map((e) => {
            const startDate = localizeDateTime(DateTimeService.fromUtcString(e.startUtc, timezone));
            const endDate = localizeDateTime(DateTimeService.fromUtcString(e.endUtc, timezone));
            return `${e.name}\n${localizeText(TextKey.FromDate)}: ${startDate}\n${localizeText(
                TextKey.ToDate
            )}: ${endDate}`;
        })
    ).join('\n');
}
